import axios from 'axios';
import {environment} from './src/environment/environment';

class InitSharedRepo {
  // Call at the very beginning
  static init() {
    axios.defaults.timeout = environment.reqTimeout;
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.baseURL = environment.baseUrl;
    InitSharedRepo.plugInterceptors();
  }

  // Call after authentication is done and make required changes
  static initAfterAuth(config: any) {
    axios.defaults.headers.common['authorization'] =
      `Bearer ${config.token}` || null;
  }

  static initClinicGroupHeader(groupId: any) {
    axios.defaults.headers.common['clinic_group_id'] = groupId || null;
  }

  static plugInterceptors(): void {
    // Request interceptor
    axios.interceptors.request.use(
      function (config): Record<string, any> {
        // Do something before request is sent
        return config;
      },
      function (error): Promise<any> {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    // Response interceptor
    // TODO :Intercept 500 errors if the server is not running
    axios.interceptors.response.use(
      function (response): any {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
      },
      function (error): Promise<any> {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        // console.log(error);
        return Promise.reject(error);
      }
    );
  }
}

export default InitSharedRepo;
